import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { TitleAndBulletsCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import Markup from '../../../../base/Markup/Markup';

export const TitleAndBulletsCard = ({
  heading,
  text,
}: TitleAndBulletsCardStoryblok) => {
  if (!heading && !text) {
    return null;
  }

  return (
    <Box as="article" overlayOverBkg>
      <Type as="h3" className="font-helvetica text-h2">
        {heading}
      </Type>
      <Markup content={text} className="mt-3 text-p1" />
    </Box>
  );
};

export default TitleAndBulletsCard;
